import { CheckInRewardType } from '@/schema'

export const DAILY_CHECK_IN_REWARD_TYPE_LABELS: Record<
	CheckInRewardType,
	string
> = {
	CREDIT: 'เครดิต',
	WHEEL: 'หมุนวงล้อ',
	DIAMOND: 'เพชร',
	FREE_SPIN: 'ฟรีสปิน',
}
